import { NestedSportsbookKey } from '../@types';

const nestedSportsbookKeys: NestedSportsbookKey[] = ['oddsChanges', 'oddsFormat'];

export const buildUserSettingsUpdate = (key: string, value: string) => {
  if (nestedSportsbookKeys.includes(value as NestedSportsbookKey)) {
    return { sportsbookConfig: { [value]: key } };
  }
  return { [value]: key };
};
